import { Component } from "react";
import { DateTime } from "luxon";
import { appContext } from "../../../../AppContext";
import { DateHelper } from "../../../../Common/DateHelper";
import { Box, Divider, Grid, Link, Skeleton } from "@mui/material";
import { IbssComponent } from "../../../../Components/Core/BaseComponent/IbssComponent";
import { GetAnnouncementDetails } from "../../../../Components/Cards/EventCard/GetAnnouncementDetails";
import IbssEventCard from "../../../../Components/Cards/EventCard/IbssEventCard";
import IbssCardDetailsDrawer from "../../../../Components/Cards/EventCard/IbssCardDetailsDrawer";
import { Announcement } from "../../../../Providers.Api/ApiCacheDataModels";
import { rights } from "../../../../Common/RightsManager";
import IbssPageHeader from "../../../../Components/Headings/PageHeading/IbssPageHeader";
import Notification from './NotificationPlaceholder.png'

export default class NewsAndEvents extends IbssComponent<IProps, IState>
{
    private get labels() { return appContext().labels; }
    private announcementHelper = new GetAnnouncementDetails({});
    private hasViewEvents = rights.FLEX.Events.View.has();
    private userHasEventReadRights = rights.DATAMODEL.TicketedEvents.Read.has();
    private userHasNewsReadRights = rights.DATAMODEL.Notifications.Read.has();

    constructor(props: IProps)
    {
        super(props);
        this.state = {
            selectedCard: null,
            drawerOpen: false,

        }
    }

    private newsCardClicked(nodeId: number, id: string): void
    {
        const selectedNews = this.props.newsData.find(news => news.nodeId === nodeId && news.id === id);
        
        if(!selectedNews)
        {
            return;
        }

        this.setState({ selectedCard: selectedNews, drawerOpen: true });
    }

    public handleCloseDrawer(): void
    {
        this.setState({ drawerOpen: false });
    }

    private getNotificationTitle(title: string, categoryLabel: string): string
    {
        return `${categoryLabel} | ${title}`;
    }

    public render(): JSX.Element
    {
        return (<>
            {this.userHasNewsReadRights && (this.props.isLoadingNews || this.props.newsData.length>0) && <Box>
                <Box display={'flex'} justifyContent={'space-between'} my={3}>
                    <IbssPageHeader
                        title={this.labels.funcNews_S}
                    />
                    <Box display={'flex'} gap={2}>
                    </Box>
                </Box>
                <Grid container spacing={3} minHeight={300}>
                    {
                        this.props.isLoadingNews ?
                            <Grid item xs={12}>
                                <NewsAndEventsSkeleton />
                            </Grid> :
                            (this.props.newsData.length > 0) &&
                                (
                                    this.props.newsData.map((news) => (
                                        <Grid item sm={12} key={news.id}>
                                            <IbssEventCard
                                                id={String(news.id)}
                                                title={this.getNotificationTitle(news.title, news.subclassification)}
                                                description={news.shortMessage}
                                                imageURI={news.imageURI && news.imageURI.trim() !== '' ? news.imageURI : Notification}
                                                status={this.announcementHelper.getNotificationStatus(news.priority)}
                                                itemDate={news.availableFrom}
                                                startTime={news.availableFrom}
                                                nodeId={news.nodeId}
                                                navigateToDetails={() => this.newsCardClicked(news.nodeId, news.id)}
                                                actionURL={news.actionURI}
                                                showDetails={true}
                                                layout={'News'}
                                            />
                                        </Grid>
                                    ))
                                )
                    }
                </Grid>
                <Box my={3} gap={3} display={'flex'} justifyContent={'center'}>
                    <Link sx={{ cursor: 'pointer',color: 'var(--ui-text-alternate)',textDecoration: 'none' }} onClick={() => this.props.navigateToRoute('/flex-my-notification')}>{this.labels.funcViewAllNews_S}</Link>
                </Box>
            <Box my={3}>
                <Divider />
            </Box>
            </Box>
            }
            {(this.userHasEventReadRights && this.hasViewEvents && (this.props.isLoadingEvents || this.props.eventsData.length>0)) &&
                <Box>
                    <Box display={'flex'} justifyContent={'space-between'} my={3}>
                        <IbssPageHeader
                            title={this.labels.funcEvents_S}
                        />
                    </Box>
                    <Grid container spacing={3}>
                        {this.props.isLoadingEvents && (
                            <Grid item xs={12}>
                                <NewsAndEventsSkeleton />
                            </Grid>
                        )}
                        {!this.props.isLoadingEvents && this.props.eventsData.length > 0 && (
                            this.props.eventsData.map((event) => (
                                <Grid item sm={12} key={event.ticketedEventId}>
                                    <IbssEventCard
                                        id={event.ticketedEventId}
                                        title={event.eventTitle}
                                        description={event.eventShortDescription}
                                        actionURL={event.webSiteUrl}
                                        imageURI={event.imageUri}
                                        fullDescription={event.eventDescription}
                                        itemDate={event.eventDate}
                                        startTime={event.eventStart}
                                        endTime={event.eventEnd}
                                        nodeId={event.nodeId}
                                        spaceName={event.spaceName}
                                        status={this.announcementHelper.getEventStatus(
                                            event.eventDate,
                                            event.isWaitingListAllowed,
                                            event.eventCapacity,
                                            event.eventAttendees,
                                            event.userIsAttending
                                        )}
                                        showDetails={this.hasViewEvents}
                                        navigateToDetails={() => this.props.navigateToDetails(event.nodeId, event.ticketedEventId)}
                                    />
                                </Grid>
                            ))
                        )}
                    </Grid>
                    <Box my={5} gap={3} display={'flex'} justifyContent={'center'}>
                        <Link sx={{ cursor: 'pointer',color: 'var(--ui-text-alternate)',textDecoration: 'none' }} onClick={() => this.props.navigateToRoute('/flex/events/mine')}>{this.labels.funcViewAllEvents_S}</Link>
                    </Box>
                </Box>}
            {/* Slide drawer to show news details */}
            {this.state.selectedCard?.id &&
                <IbssCardDetailsDrawer
                    open={this.state.drawerOpen}
                    onClose={() => this.handleCloseDrawer()}
                    nodeId={this.state.selectedCard.nodeId}
                    availableFrom={this.state.selectedCard.availableFrom}
                    imageURI={this.state.selectedCard.imageURI.trim() !== '' ? this.state.selectedCard.imageURI : Notification}
                    priority={this.state.selectedCard.priority}
                    title={this.state.selectedCard.title}
                    shortMessage={this.state.selectedCard.shortMessage}
                    message={this.state.selectedCard.message}
                />
            }
        </>
        )
    }


}

export class NewsAndEventsSkeleton extends Component
{
    public render(): JSX.Element
    {
        return (
            <>
                <Box sx={{ display: 'flex', padding: '10px',width:'100%'}} bgcolor="background.paper" mt={2}>
                    <Skeleton variant="rectangular" width={100} height={100} />
                    <Box style={{ width: '100%' }}>
                        <Skeleton sx={{ margin: '15px', marginBottom: '10px' }} variant="rectangular" width={'70%'} height={10} />
                        <Skeleton sx={{ margin: '15px' }} variant="rectangular" width={'50%'} height={10} />
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', padding: '10px',width:'100%'}} bgcolor="background.paper" mt={2}>
                    <Skeleton variant="rectangular" width={100} height={100} />
                    <Box style={{ width: '100%' }}>
                        <Skeleton sx={{ margin: '15px', marginBottom: '10px' }} variant="rectangular" width={'70%'} height={10} />
                        <Skeleton sx={{ margin: '15px' }} variant="rectangular" width={'50%'} height={10} />
                    </Box>
                </Box>
            </>
        )
    }
}


export interface IProps
{
    newsData: AnnouncementView[];
    eventsData: IEvent[];
    isLoadingNews: boolean;
    isLoadingEvents: boolean;
    navigateToRoute: (path: string) => void;
    navigateToDetails: (nodeId: number, eventId: string) => void;
}

export interface IState
{
    selectedCard: AnnouncementView | null,
    drawerOpen: boolean,
}

export interface IListOption<TValue>
{
    label: string,
    value: TValue,
}

export interface IEvent
{
    nodeId: number;
    ticketedEventId: string;
    bookingId: string;
    eventTitle: string;
    eventShortDescription: string;
    eventDescription: string;
    webSiteUrl: string;
    imageUri: string;
    eventDate: DateTime;
    eventStart: DateTime;
    eventEnd: DateTime;
    eventCapacity: number;
    isWaitingListAllowed: boolean;
    invitePermission: string;
    eventStatus: string;
    eventAttendees: number;
    userIsAttending: boolean;
    spaceName: string;
}

enum NotificationTarget
{
    None = 0,
    RoamerAndFlex = 1,
    Inspire = 2,
    Unity = 4,
    Guest = 8,
}
export class AnnouncementView
{
    public id = '';
    public title = '';
    public priority = 0;
    public recordId = '';
    public message = '';
    public shortMessage = '';
    public reminders =  "";
    public type = 0;
    public status = '';
    public userEmail = '';
    public sent = 0;
    public target = NotificationTarget.None;
    public device = null;
    public classification = '';
    public subclassification = '';
    public availableFrom = DateHelper.null();
    public expiryDate = DateHelper.null();
    public hasImage = 0;
    public imageURI = '';
    public actionURI = '';
    public nodeId = 0;


    public static fromAnnouncementToView(announcement: Announcement): AnnouncementView
    {
        return {
            id: `${announcement.Notification_Id}`,
            nodeId: announcement.Node_Id,
            title: announcement.Notification_Title,
            priority: announcement.Notification_Priority,
            recordId: announcement.Notification_Record_Id,
            message: announcement.Notification_Message,
            shortMessage: announcement.Notification_Short_Message,
            reminders: announcement.Notification_Reminders,
            type: announcement.Notification_Type,
            status: announcement.Notification_Status,
            userEmail: announcement.Notification_User_Email,
            sent: announcement.Notification_Sent,
            target: this.getTargetName(announcement.Notification_Target),
            device: announcement.Notification_Device,
            classification: announcement.Classification,
            subclassification: announcement.Subclassification,
            availableFrom: announcement.Available_From,
            expiryDate: announcement.Expiry_Date,
            hasImage: announcement.Has_Image,
            imageURI: announcement.ImageURI,
            actionURI: announcement.ActionURI,
        }
    }

    public static getTargetName(target: number | null): NotificationTarget
    {
        switch(target)
        {
            case 0:
                return NotificationTarget.None;
            case 1:
                return NotificationTarget.RoamerAndFlex;
            case 2:
                return NotificationTarget.Inspire;
            case 4:
                return NotificationTarget.Unity;
            case 8:
                return NotificationTarget.Guest
            default:
                return NotificationTarget.None;
        }
    }
}